import React from "react";
import ClassificationEditor from "../components/ClassificationEditor";

export default function ServicesView(): JSX.Element {
  return <ClassificationEditor />;
}
